export default "__VITE_ASSET__CUgBQWdf__"